import { Property } from "./types";
import { TFunction } from "i18next";

export const getTableProp = <T extends any>(item: T, property: Property<T>, t: TFunction): any => (
  typeof property === "function"
    ? property(item, t)
    : item[property]
);
